// Tela cheia de "estamos processando", com o spinner verde das telas de
// redirect. Usada onde o clique demora o suficiente para a pessoa duvidar que
// ele funcionou — checkout e encerramento de etapa. Injeta um overlay FRESCO no
// <body>, que sobrevive às respostas turbo que trocam #main, e tem rede de
// segurança: se a página não navegar, ele sai sozinho.
export function showProcessingOverlay({
  id = "processing-overlay",
  title = "Processando",
  subtitle = "",
  timeout = 30000
} = {}) {
  if (document.getElementById(id)) return

  document.body.style.overflow = "hidden"
  document.querySelector("jdiv")?.remove()

  const overlay = document.createElement("div")
  overlay.id = id
  overlay.style.cssText =
    "position:fixed;inset:0;z-index:9999;background:rgba(255,255,255,.96);" +
    "display:flex;align-items:center;justify-content:center;backdrop-filter:blur(2px);"
  overlay.innerHTML = `
    <style>@keyframes vc-spin{to{transform:rotate(360deg)}}</style>
    <div style="display:flex;flex-direction:column;align-items:center;gap:18px;padding:32px;text-align:center;font-family:system-ui,-apple-system,'Segoe UI',Roboto,sans-serif;">
      <div style="width:60px;height:60px;border:4px solid #dcfce7;border-top-color:#16a34a;border-radius:9999px;animation:vc-spin .8s linear infinite;"></div>
      <div>
        <h3 style="margin:0;font-size:18px;font-weight:600;color:#14532d;">${title}</h3>
        <p style="margin:6px auto 0;font-size:14px;color:#6b7280;max-width:300px;">${subtitle}</p>
      </div>
    </div>`
  document.body.appendChild(overlay)

  setTimeout(() => hideProcessingOverlay(id), timeout)

  return overlay
}

// A recusa do servidor (falta o lacre, falta a assinatura) volta na mesma
// página: sem tirar o overlay, a pessoa ficaria olhando um spinner por cima da
// mensagem que explica o que falta.
export function hideProcessingOverlay(id = "processing-overlay") {
  document.getElementById(id)?.remove()
  document.body.style.overflow = ""
}
